module.exports = __webpack_public_path__ + "img/pg1.38669afe.png";